module.exports = __webpack_public_path__ + "static/media/card-home-marketplace.f59012db.png";